import qs from "qs";
import core from "@/core/index";

class UserService {
  register(params) {
    const strParam = JSON.stringify(params);
    return new Promise((resolve, reject) => {
      core.http
        .postJson(`/api/user/register`, strParam)
        .then((data) => {
          //console.log('result: ', data);
          resolve(data);
        })
        .catch((reason) => {
          //console.log('error: ', reason);
          reject(reason);
        });
    });
  }

   login(params) {
    const strParam = qs.stringify(params);
    return new Promise((resolve, reject) => {
      core.http
        .post(`/api/login`, strParam)
        .then((data) => {
          //console.log('result: ', data);
          resolve(data);
        })
        .catch((reason) => {
          //console.log('error: ', reason);
          reject(reason);
        });
    });
  }

  logout() {
    return new Promise((resolve, reject) => {
      core.http
        .getJson(`/api/logout`)
        .then((data) => {
          // console.log('result: ', data);
          resolve(data);
        })
        .catch((reason) => {
          // console.log('error: ', reason);
          reject(reason);
        });
    });
  }

  getMyInfo() {
    return new Promise((resolve, reject) => {
      core.http
        .getJson(`/api/user/me`, { ignoreAlertModal: true })
        .then((data) => {
          //console.log('result: ', data);
          if (data.user != null) {
            resolve(data.user);
          } else {
            reject({ message: "not found item" });
          }
        })
        .catch((reason) => {
          //console.log('error: ', reason);
          reject(reason);
        });
    });
  }

  //: { phone; name; email }
  update(params) {
    const strParam = JSON.stringify(params);
    return new Promise((resolve, reject) => {
      core.http
        .putJson(`/api/user/me`, strParam)
        .then((data) => {
          //console.log('result: ', data);
          resolve(data);
        })
        .catch((reason) => {
          //console.log('error: ', reason);
          reject(reason);
        });
    });
  }

  //: {
  //     newPassword;
  //     newConfirmPassword;
  //     currentPassword;
  //   }
  updatePassword(params) {
    const strParam = JSON.stringify(params);
    return new Promise((resolve, reject) => {
      core.http
        .putJson(`/api/user/me/password`, strParam)
        .then((data) => {
          //console.log('result: ', data);
          resolve(data);
        })
        .catch((reason) => {
          //console.log('error: ', reason);
          reject(reason);
        });
    });
  }
}

export default new UserService();
